// src/i18n/index.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import enTranslations from "../Language/en.json";
import hiTranslations from "../Language/hi.json";
import esTranslations from "../Language/es.json";
import frTranslations from "../Language/fr.json";
import deTranslations from "../Language/de.json";
import itTranslations from "../Language/it.json";
import nlTranslations from "../Language/nl.json"; // Assuming you have a Dutch translation file

// Translation resources
const resources = {
  en: enTranslations,
  fr: frTranslations,
  de: deTranslations,
  it: itTranslations,
  nl: nlTranslations, // Dutch translations
  // Add other languages if needed
  // nl: {
  //   translation: {
  //     selectLanguage: "Selecteer Taal",
  //     hotels: "Hotels",
  //     excursions: "Excursies",
  //     transfers: "Transfers",
  //     tours: "Tours",
  //     contactUs: "Contact Ons",
  //     // Add more Dutch translations as needed
  //   },
  // },
  // fr: {
  //   translation: {
  //     selectLanguage: "Sélectionner la Langue",
  //     hotels: "Hôtels",
  //     excursions: "Excursions",
  //     transfers: "Transferts",
  //     tours: "Tours",
  //     contactUs: "Nous Contacter",
  //     // Add more French translations as needed
  //   },
  // },
  // de: {
  //   translation: {
  //     selectLanguage: "Sprache Auswählen",
  //     hotels: "Hotels",
  //     excursions: "Ausflüge",
  //     transfers: "Transfers",
  //     tours: "Touren",
  //     contactUs: "Kontakt",
  //     // Add more German translations as needed
  //   },
  // },
  // it: {
  //   translation: {
  //     selectLanguage: "Seleziona Lingua",
  //     hotels: "Hotel",
  //     excursions: "Escursioni",
  //     transfers: "Trasferimenti",
  //     tours: "Tour",
  //     contactUs: "Contattaci",
  //     // Add more Italian translations as needed
  //   },
  // },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    debug: false,

    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
